import { showLoader, hideLoader, showLoaderImmediate, hideLoaderImmediate, setIsOnline, resetStore, resetStoreNoReload } from '../reducers/slices/loaderSlice';
import { setVendorDetails, setProgramInfo } from '../reducers/slices/vendorSlice';
import { setSnackBarMsg, setVersionMismatch, updateUploadPercentage, clearUploadPercentage } from '../reducers/slices/uiSlice';
import { setBotMessages, setChatbotCollapsed } from '../reducers/slices/chatbotSlice';
import { setGuardedFormDirtyState } from '../reducers/slices/formSlice';
import { setReasonCatalog } from '../reducers/slices/reasonCatalogSlice';
export const app_actions = {
    showLoader,
    hideLoader,
    showLoaderImmediate,
    hideLoaderImmediate,
    setIsOnline,
    resetStore,
    resetStoreNoReload,
    snackbarMessage: setSnackBarMsg,
    updateUploadPercentage,
    clearUploadPercentage,
    vendorConfigDetails: (data) => setVendorDetails(data === null || data === void 0 ? void 0 : data.vendor_config_details),
    programDetails: (data) => setProgramInfo(data === null || data === void 0 ? void 0 : data.selectedProgramInfo),
    setBotMessages,
    setChatbotCollapsed,
    setVersionMismatch,
    setGuardedFormDirtyState,
    setReasonCatalog,
};
